// src/pages/About.jsx
import React from "react";
import "../styles/About.css";
import aboutHero from "../assets/yog1.png";
import ritualImg from "../assets/aab1.png"; // optional additional visuals
import healingImg from "../assets/about.png"; // optional additional visuals

function About() {
  return (
    <section className="about-main">
      <div className="about-hero">
        <div className="hero-text">
          <h1>VEDYO = <span>“Veda + Yoga”</span></h1>
          <p className="tagline">An evolved state of conscious living.</p>
        </div>
        <img src={aboutHero} alt="VEDYO Illustration" className="hero-img" />
      </div>

      <div className="about-sectionn">
        <h2 className="section-heading">About VEDYO</h2>
        <p className="section-para">
          <strong>VEDYO</strong> is a wellness space deeply rooted in the timeless traditions of Yoga, Ayurveda, Naturopathy, and Vedic sciences. Inspired by India’s ancient healing wisdom, VEDYO offers an environment where individuals can reconnect with their body, mind, and spirit—through authentic practices, personal attention, and mindful rituals.
        </p>
        <p className="section-para">
          At VEDYO, wellness is not a trend—it’s a way of life. We guide each person through a journey of self-healing and rediscovery, using holistic therapies like:
        </p>
        <ul className="list-points">
          <li>Traditional yoga based on Patanjali Yog Darshan</li>
          <li>Ayurvedic detox and rejuvenation therapies (Panchkarma)</li>
          <li>Spiritual rituals like Yagya and Hawan</li>
          <li>Meditation and lifestyle counselling</li>
          <li>Personalized retreats and daily wellness routines</li>
        </ul>
      </div>

      <div className="image-row">
        <img src={ritualImg} alt="Vedic Ritual" />
        <img src={healingImg} alt="Healing Therapy" />
      </div>

      <div className="about-sectionn">
        <h2 className="section-heading">Why VEDYO Was Created</h2>
        <p className="section-para">
          VEDYO was born from a simple but powerful vision: <strong>To reconnect people with the healing power of India’s spiritual and wellness heritage.</strong>
        </p>
        <p className="section-para">
          As the founder, trained in the Gurukul tradition of Haridwar, I experienced firsthand how life-changing these practices can be when lived in their purest form. But today’s fast-paced world has distanced people from their natural state of balance—physically, mentally, and spiritually.
        </p>
        <p className="section-para">
          VEDYO is not just a wellness brand—it is a mission to make traditional Indian health practices accessible, meaningful, and personal. This space is for all of us—you and me—to pause, reflect, and heal.
        </p>
        <p className="quote">“Through VEDYO, we invite you to begin your journey back to yourself. A journey through tradition. A journey toward wholeness.”</p>
      </div>
    </section>
  );
}

export default About;
